import { type UseQueryOptions } from '@tanstack/react-query'
import { useApiUrl } from '@/hooks/useApiUrl'
import { useQuery } from '@/lib/use-query'
import { getStakerStats, type StakerStats } from './api'

export function useStakerStats(
	address?: string,
	queryOpts?: Omit<UseQueryOptions<StakerStats, unknown, StakerStats>, 'queryKey' | 'queryFn' | 'enabled'>
) {
	const apiUrl = useApiUrl()

	return useQuery<StakerStats>({
		...queryOpts,
		enabled: !!address,
		queryKey: ['staker-stats', address],
		queryFn: () => getStakerStats(apiUrl, address as string)
	})
}
